import { ensureDownloaded } from 'serviceWorker/channelServers/entitySource';
import { get as dbGetIssueFormData } from 'serviceWorker/db/issueForm/issueForm';
import { getOne as dbGetOneProject } from 'serviceWorker/db/projects/projects';
import { get as getSelectedProject } from 'serviceWorker/db/selectedProject';
import { IssueFormEntity } from 'serviceWorker/repository/issueForm/issueForm';
import { retry } from 'shared/utils/retry';
import { issueFormSource } from './issueFormSource';

export async function getIssueForm(): Promise<IssueFormEntity[]> {
  const selectedProject = await retry(() => getSelectedProject(), 5);
  if (!selectedProject?._id) {
    throw new Error('Project is not selected.');
  }
  const [issueForm, project] = await Promise.all([
    dbGetIssueFormData(),
    retry(
      () =>
        dbGetOneProject(selectedProject._id).then((project) => {
          if (!project) {
            throw new Error('Recieved empty project data');
          }
          return project;
        }),
      10
    ),
  ]);

  if (!project) {
    throw new Error('Cannot get project data in 10 reties.');
  }

  if (!issueForm.length) {
    // Not downloaded yet: download it and wait (also ends on a failed download).
    await ensureDownloaded(issueFormSource.storage);
    return dbGetIssueFormData();
  }

  return issueForm;
}
